import { alertTypes } from "../actions/alerts";

const initialState = {
  isLoading: false,
  alertStatusCountsIsLoading: false,
  alertCountIsLoading: false,
  shouldUpdate: false,
  isDownloaded: "",
  ui: {
    alertLocation: {
      IsLocationDetails: "",
      },
  },
  filters: {
    isLoaded: false,
    status: [],
    level: "",
    subject: "",
    shipmentname: "",
    device: "",
    lastUpdated: "",
    organization: [],
    location: [],
    sort: [
      {
        field: "createdon",
        order: "desc",
      },
    ],
    pagenumber: 0,
    limitnumber: 50,
  },
  data: {
    statuses: [
      {
        text: "New",
        value: true,
      },
      {
        text: "Acknowledged",
        value: true,
      },
      {
        text: "Resolved",
        value: true,
      },
      {
        text: "Auto Resolved",
        value: false,
      },
    ],
    status: [
      {
        text: "New",
        value: false,
      },
      {
        text: "Acknowledged",
        value: false,
      },
      {
        text: "Resolved",
        value: false,
      },
      {
        text: "Auto Resolved",
        value: false,
      },
    ],
    levels: [
      {
        label: "Warning",
        value: false,
      },
      {
        label: "Critical",
        value: false,
      },
      {
        label: "Notification",
        value: false,
      },
    ],
    alerts: [],
    devices: [],
    locations: [],
    organizations: [],
  },
  bulkUpdate: {
    statuses: [
      {
        label: "All",
        value: "",
      },
      // {
      //   label: "New",
      //   value: "new",
      // },
      {
        label: "Acknowledged",
        value: "acknowledged",
      },
      {
        label: "Resolved",
        value: "resolved",
      },
    ],
    levels: [
      {
        label: "All",
        value: "",
      },
      {
        label: "Warning",
        value: "warning",
      },
      {
        label: "Critical",
        value: "critical",
      },
    ],
    organizations: [],
    locations: [],
    isFiltered: false,
    isUpdating: false,
    isFiltering: false,
    filters: {
      fields: {
        subject: "",
        status: { new: false, acknowledged: false, resolved: false },
        level: { warning: false, error: false },
        device: [],
        organization: [],
        location: [],
        lastUpdated: "",
      },
      count: 0,
    },
    fields: {
      status: "",
      comment: "",
    },
  },
  singleUpdate: {
    isUpdating: false,
    currentData: {},
    fields: {
      status: "",
      comment: "",
    },
  },
  notification: {
    isActive: false,
    type: "success",
    message: "",
    description: "",
    style: { backgroundColor: "#d4edda", color: "#155724" },
  },
  alertCounts: {
    total: 0,
    warning: 0,
    error: 0,
  },
  alertStatusCounts: {
    new: 0,
    acknowledged: 0,
    resolved: 0,
    autoresolved: 0,
  },
  error: null,
};


const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case alertTypes.FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        alertStatusCountsIsLoading: true,
        alertCountIsLoading: true
      };
    case alertTypes.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          ...action.payload.list,
        },
        filters: {
          ...state.filters,
          isLoaded: true,
        },
        bulkUpdate: {
          ...state.bulkUpdate,
          locations:
            action.payload.bulkUpdate.locations.length > 0
              ? [
                ...state.bulkUpdate.locations,
                {
                  label: "All",
                  value: "",
                },
                ...action.payload.bulkUpdate.locations,
              ]
              : [...state.bulkUpdate.locations],
          organizations:
            action.payload.bulkUpdate.organizations.length > 0
              ? [
                ...state.bulkUpdate.organizations,
                {
                  label: "All",
                  value: "",
                },
                ...action.payload.bulkUpdate.organizations,
              ]
              : [...state.bulkUpdate.organizations],
        },
        error: null,
      };
      case alertTypes.UPDATE_PAGINATION_REQUEST:
            return {
              ...state,
              shouldUpdate: action.payload.shouldUpdate,
              data: {
                ...state.data,
                ...action.payload.data,
              },
            };
    case alertTypes.UPDATE_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
          sort: action.payload.sort,
        },
      };
    case alertTypes.ALERT_COUNT_SUCCESS:
      return {
        ...state,
        alertCountIsLoading: false,
        alertCounts: action.payload,
      };
    case alertTypes.ALERT_STATUS_COUNT_SUCCESS:
      return {
        ...state,
        alertStatusCountsIsLoading: false,
        alertStatusCounts: action.payload,
      };
    case alertTypes.FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        alertStatusCountsIsLoading: false,
        alertCountIsLoading: false,
        isLoaded: false,
        data: {
          ...state.data,
          alerts: [],
        },
        alertCounts: {
          total: 0,
          warning: 0,
          error: 0,
        },
        alertStatusCounts: {
          new: 0,
          acknowledged: 0,
          resolved: 0,
          autoresolved: 0,
        },
        error: action.payload,
      };
      case alertTypes.UPDATE_UI:
        return {
          ...state,
          ui: {
            ...state.ui,
            [action.payload.key]: {
              ...state.ui[action.payload.key],
              ...action.payload.value,
            },
          },
        };
    case alertTypes.BULK_UPDATE_FILTER_FIELD:
      return {
        ...state,
        bulkUpdate: {
          ...state.bulkUpdate,
          filters: {
            ...state.bulkUpdate.filters,
            fields: {
              ...state.bulkUpdate.filters.fields,
              ...action.payload,
            },
          },
        },
      };
    case alertTypes.BULK_UPDATE_FIELD:
      return {
        ...state,
        bulkUpdate: {
          ...state.bulkUpdate,
          fields: {
            ...state.bulkUpdate.fields,
            ...action.payload,
          },
        },
      };
    case alertTypes.BULK_UPDATE_FILTER:
      return {
        ...state,
        bulkUpdate: {
          ...state.bulkUpdate,
          isFiltered: action.payload,
          isFiltering: true,
        },
      };
    case alertTypes.BULK_UPDATE_FILTER_BACK:
      return {
        ...state,
        bulkUpdate: {
          ...state.bulkUpdate,
          isFiltered: false,
        },
      };
    case alertTypes.BULK_UPDATE_FILTER_SUCCESS:
      return {
        ...state,
        bulkUpdate: {
          ...state.bulkUpdate,
          isFiltering: false,
          filters: {
            ...state.bulkUpdate.filters,
            count: action.payload,
          },
        },
      };
    case alertTypes.BULK_UPDATE_FILTER_FAILURE:
      return {
        ...state,
        bulkUpdate: {
          ...state.bulkUpdate,
          isFiltering: false,
          filters: {
            ...state.bulkUpdate.filters,
            count: 0,
          },
        },
      };
    case alertTypes.BULK_UPDATE_SUBMIT:
      return {
        ...state,
        bulkUpdate: {
          ...state.bulkUpdate,
          isUpdating: true,
        },
      };
    case alertTypes.BULK_UPDATE_RESPONSE:
      return {
        ...state,
        bulkUpdate: {
          ...state.bulkUpdate,
          isFiltered: false,
          isUpdating: false,
          filters: {
            fields: {
              subject: "",
              status: { new: false, acknowledged: false, resolved: false },
              level: { warning: false, error: false },
              device: [],
              organization: [],
              location: [],
              lastUpdated: "",
            },
            count: 0,
          },
          fields: {
            status: "",
            comment: "",
          },
        },
        notification: {
          ...state.notification,
          ...action.payload,
        },
      };
    case alertTypes.SINGLE_UPDATE_REQUEST:
      return {
        ...state,
        singleUpdate: {
          ...state.singleUpdate,
          currentData: action.payload.current,
          fields: action.payload.fields,
        },
      };
    case alertTypes.SINGLE_UPDATE_SUBMIT:
      return {
        ...state,
        singleUpdate: {
          ...state.singleUpdate,
          isUpdating: true,
        },
      };
    case alertTypes.SINGLE_UPDATE_FIELD:
      return {
        ...state,
        singleUpdate: {
          ...state.singleUpdate,
          fields: {
            ...state.singleUpdate.fields,
            ...action.payload,
          },
        },
      };
    case alertTypes.SINGLE_UPDATE_RESPONSE:
      return {
        ...state,
        singleUpdate: {
          ...state.singleUpdate,
          isUpdating: false,
          currentData: {},
          fields: {
            status: "",
            comment: "",
          },
        },
        notification: {
          ...state.notification,
          ...action.payload,
        },
      };
    case alertTypes.DOWNLOAD_REQUEST:
      return {
        ...state,
        isDownloaded: "Downloading....",
      };
    case alertTypes.DOWNLOAD_SUCCESS:
      return {
        ...state,
        isDownloaded: "Downloaded",
      };
    case alertTypes.DOWNLOAD_FAILURE:
      return {
        ...state,
        isDownloaded: "Something Went Wrong",
        error: action.payload,
      };
    case "RESET_BULK_UPDATE_FORM":
      return {
        ...state,
        bulkUpdate: {
          ...state.bulkUpdate,
          isFiltered: false,
          isFiltering: false,
          filters: {
            fields: {
              subject: "",
              status: {},
              level: {},
              organization: [],
              location: [],
            },
            count: 0,
          },
          fields: {
            status: "",
          },
        },
      };
    default:
      return state;
  }
};

export default alertReducer;
